import React from 'react';

const Hankkeet = () => {
    return (
        <div style={{ padding: '4rem 2rem', textAlign: 'center', minHeight: '60vh' }}>
            <p style={{ marginTop: '1rem', fontSize: '1.2rem' }}>
                Remena valmistelee tällä hetkellä nuorten elokuvaleirihanketta, joka odottaa ELY:n päätöstä. Tiedotetaan lisää myöhemmin.
            </p>
        </div>
    );
};

export default Hankkeet;